var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main-card logout"},[_c('div',{staticClass:"form-content"},[_c('div',{staticClass:"heading"},[_c('img',{attrs:{"src":"/assets/img/Blits-logo-white.png"}}),_c('br'),_c('br'),_c('h5',[_vm._v("Successfully logged out! Redirecting you in a bit...")])])])])])
}]

export { render, staticRenderFns }